import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultFlexAlignDirective } from './flex-align';
import { DefaultFlexOffsetDirective } from './custom-flex-offset';
import { DefaultFlexOrderDirective } from './custom-flex-order';
import { DefaultLayoutGapDirective } from './custom-layout-gap';
import { DefaultLayoutAlignDirective } from './custom-layout-align';
import { DefaultLayoutDirective } from './custom-layout';
import { DefaultShowHideDirective } from './show-hide';
import { DefaultImgSrcDirective } from './img-src';
import { DefaultStyleDirective } from './style';
import { DefaultFlexDirective } from './flex';
import { DefaultClassDirective } from './class';






@NgModule({
    imports: [
        CommonModule,
        DefaultLayoutDirective,
        DefaultLayoutGapDirective,
        DefaultLayoutAlignDirective,
        DefaultFlexOrderDirective,
        DefaultFlexOffsetDirective,
        DefaultFlexAlignDirective,
        DefaultFlexDirective,
        DefaultShowHideDirective,
        DefaultClassDirective,
        DefaultStyleDirective,
        DefaultImgSrcDirective
    ],
    exports: [
        DefaultLayoutDirective,
        DefaultLayoutGapDirective,
        DefaultLayoutAlignDirective,
        DefaultFlexOrderDirective,
        DefaultFlexOffsetDirective,
        DefaultFlexAlignDirective,
        DefaultFlexDirective,
        DefaultShowHideDirective,
        DefaultClassDirective,
        DefaultStyleDirective,
        DefaultImgSrcDirective,
    ]
})
export class CustomFlexLayoutModule {
    static withConfig: any;
}
